<template>
    <div class="py-4 md:py-6 md:flex items-center">
        <div class="hidden md:block w-28 h-28 rounded-full leading-[7rem] text-center flex-shrink-0 mr-5  overflow-hidden shine" />
        <div>
            <transition
                name="opacity"
                mode="out-in"
            >
                <div class="w-[9rem] mt-7">
                    <SkeletonSentence class="w-1/2 " />
                    <SkeletonSentence class="w-full" />
                    <SkeletonSentence class="w-1/3" />
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import SkeletonSentence from '@/components/skeletons/SkeletonSentence.vue';

export default {
    components: {
        SkeletonSentence,
    }
};
</script>
